<template>
    <div class="alkane">
        <ul>
            <li>C<sub>n</sub>H<sub>2n+2</sub></li>
            <li>sp<sup>3</sup> hybridisiert</li>
            <li>unpolar</li>
            <li>niedrige Siedetemp.</li>
            <li>brennbar</li>
            <li>-an</li>
            <li>
                Nachweis (radikalische Substitution):<br />Entfärbt Br<sub
                    >2</sub
                >
                Polymerisation, nur unter Lichteinfluss
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'alkane',
};
</script>
